<template>
    <div :class="classes">
        <!--        <quill-->
        <!--            :key="mentionsDisabled ? 1 : 0"-->
        <!--            ref="texteditor"-->
        <!--            v-model="content"-->
        <!--            output="html"-->
        <!--            :config="config"-->
        <!--        />-->
    </div>
</template>

<script>
import InitialsMixin from '../../mixins/initials';
import { icons } from '../../components/Icon/VectorIcon';

export default {
    mixins: [InitialsMixin],

    props: {
        value: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        form: { type: Object },
        mentions: { type: Array, default: [] },
        mentionsDisabled: { type: Boolean, default: true },
        mentionsRenderItem: { type: Function },
    },

    emits: ['handleInit', 'handleChange', 'handleSelection', 'handleFocus', 'handleBlur', 'handleKeyDown', 'handleKeyUp', 'handleDrop', 'handleClick'],

    data() {
        return {
            content: '',
            editor: null,
        };
    },

    computed: {
        config() {
            const modules = {
                toolbar: [],
            };

            if (!this.mentionsDisabled) {
                let values = this.mentions;

                if (!Array.isArray(values)) {
                    values = [];
                }

                modules.mention = {
                    allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                    mentionDenotationChars: ['@', '#'],
                    defaultMenuOrientation: 'top',
                    renderItem: (item) => {
                        if (this.mentionsRenderItem) {
                            return this.mentionsRenderItem(item);
                        }

                        const name = {
                            first_name: item.first_name || '',
                            last_name: item.last_name || '',
                        };
                        const options = {
                            classes: 'svg-inline--fa fa-w-14',
                        };
                        const classes =
                            item.type === 'inbox'
                                ? 'image is-24x24 is-avatar'
                                : 'image is-24x24 avatar-initials';

                        return `
                            <div class="mention__item">
                                <figure
                                    class="${classes}"
                                    style="background-color: ${item.color}"
                                >
                            ${
                            item.type === 'inbox'
                                ? `<span class="icon" style="fill: #4794EC;">${icons(options)['inbox-info']}</span>`
                                : `<span>${this.initials(name)}</span>`
                            }
                                </figure>
                                <div class="mention__content">
                            ${
                            item.type === 'inbox'
                                ? `<span><strong class="mention__name">@${item.first_name}</strong> - Notify everyone in this inbox</span>`
                                : `<strong class="mention__name">${item.first_name} ${item.last_name}</strong>`
                            }
                                    ${item.type === 'members' ? '<span class="mention__label">Not in inbox</span>' : ''}
                                </div>
                            </div>
                        `;
                    },
                    source: (searchTerm, renderList, mentionChar) => {
                        if (mentionChar === '@') {
                            if (searchTerm.length === 0) {
                                renderList(values, searchTerm);
                            } else {
                                const matches = [];
                                for (let i = 0; i < values.length; i++)
                                    if (
                                        ~values[i].value
                                            .toLowerCase()
                                            .indexOf(searchTerm.toLowerCase())
                                    )
                                        matches.push(values[i]);
                                renderList(matches, searchTerm);
                            }
                        }
                    },
                };
            }

            return {
                placeholder: this.placeholder,
                readOnly: this.disabled,
                modules: modules,
            };
        },

        classes() {
            return {
                texteditor: true,
                texteditor__hideToolbar: true,
                texteditor__disabled: this.disabled,
            };
        },
    },

    watch: {
        mentionsDisabled(value) {
            this.$emit('handleInit');
        },

        value(value) {
            if (!value) this.editor.setText('');
        },

        disabled(value) {
            if (value) {
                this.editor.disable();
            } else {
                this.editor.enable();
            }
        },

        placeholder(value) {
            this.editor.root.setAttribute('data-placeholder', value);
        },
    },

    methods: {
        init() {
            this.destroyEvents();

            this.editor = this.$refs.texteditor.editor;

            this.initEvents();
        },

        handleChange(e) {
            let text = '';

            text = this.editor.getTextMention();

            this.$emit('handleChange', text);
        },

        handleSelection(...args) {
            if (args) this.$emit('handleSelection', args);
        },

        handleFocus() {
            this.$emit('handleFocus');
        },

        handleBlur() {
            this.$emit('handleBlur');
        },

        handleKeyDown(e) {
            this.$emit('handleKeyDown', e);
        },

        handleKeyUp(e) {
            this.$emit('handleKeyUp', e);
        },

        handleDrop(e) {
            this.$emit('handleDrop', e);
        },

        handleClick(e) {
            this.$emit('handleClick', e);
        },

        initEvents() {
            if (this.editor) {
                this.editor.on('text-change', this.handleChange);
                this.editor.on('selection-change', this.handleSelection);
                this.editor.root.addEventListener('focus', this.handleFocus);
                this.editor.root.addEventListener('blur', this.handleBlur);
                this.editor.root.addEventListener('keydown', this.handleKeyDown);
                this.editor.root.addEventListener('keyup', this.handleKeyUp);
                this.editor.root.addEventListener('drop', this.handleDrop);
                this.editor.root.addEventListener('click', this.handleClick);
            }
        },

        destroyEvents() {
            if (this.editor) {
                this.editor.off('text-change', this.handleChange);
                this.editor.off('selection-change', this.handleSelection);
                this.editor.root.removeEventListener('focus', this.handleFocus);
                this.editor.root.removeEventListener('blur', this.handleBlur);
                this.editor.root.removeEventListener('keydown', this.handleKeyDown);
                this.editor.root.removeEventListener('keyup', this.handleKeyUp);
                this.editor.root.removeEventListener('drop', this.handleDrop);
            }
        },

        spliceSplit(str, index, count, add) {
            const ar = str.split('');
            ar.splice(index, count, add);

            return ar.join('');
        },
    },

    mounted() {
        this.init();
    },

    beforeUnmount() {
        this.destroyEvents();
    },
};
</script>
